/* eslint-disable @typescript-eslint/no-explicit-any */
import { FunctionComponent, useState } from 'react'
import { PhoneInput } from 'shared/components/phone-input/PhoneInput'
import { useAppDispatch, useAppSelector } from 'store/store'
import { updateUser } from '../../../../store/reducers/userReducer'
import { TextInput } from 'shared/components/text-input/TextInput'
import { theme } from 'styles/theme'
import Checkbox from 'shared/components/checkbox/Checkbox'
import { SignupTexts } from 'constants/signup-texts'
import { useUpdateSfUserMutation } from 'store/api-slices/userSlice'
import styles from './ContactDetailsForm.module.css'

interface Props {
  setErrors: React.Dispatch<
    React.SetStateAction<{
      id?: boolean | undefined
      dob?: boolean | undefined
      phoneNum?: boolean | undefined
      firstName?: boolean | undefined
      lastName?: boolean | undefined
      address?:
        | {
            city?: boolean | undefined
            street?: boolean | undefined
            postalCode?: boolean | undefined
          }
        | undefined
      gender: boolean
    }>
  >
  errors: {
    id?: boolean | undefined
    dob?: boolean | undefined
    phoneNum?: boolean | undefined
    firstName?: boolean | undefined
    lastName?: boolean | undefined
    address?:
      | {
          city?: boolean | undefined
          street?: boolean | undefined
          postalCode?: boolean | undefined
        }
      | undefined
    gender: boolean
  }
}

const ContactDetailsForm: FunctionComponent<Props> = ({
  errors,
  setErrors,
}) => {
  const dispatch = useAppDispatch()
  const user = useAppSelector((state) => state.user)
  const formData = useAppSelector((state) => state.user.personalDetails)
  const [updateSfUser] = useUpdateSfUserMutation()
  const [isLoading, setIsLoading] = useState(false)

  const handlePhoneChange = (value: any, error?: boolean) => {
    setErrors({ ...errors, phoneNum: error })
    dispatch(
      updateUser({
        ...user,
        personalDetails: { ...formData, phoneNum: value },
      }),
    )
  }

  const handleNewsletterChange = async () => {
    if (isLoading) return

    const newValue = !user?.newsletter

    dispatch(
      updateUser({
        ...user,
        newsletter: newValue,
      }),
    )

    setIsLoading(true)

    try {
      await updateSfUser({
        ...formData,
        newsletter: newValue,
      }).unwrap()
    } catch (error) {
      console.error('[ContactDetailsForm] Error updating newsletter:', error)
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <>
      <PhoneInput
        value={formData?.phoneNum}
        hasError={errors.phoneNum}
        errorText={'מספר נייד לא תקין'}
        callback={handlePhoneChange}
        disabled={true}
        labelText={'מספר טלפון נייד'}
        color={theme.white}
        disabledOpacityStyle
      />

      <TextInput
        color={theme.white}
        value={user?.email || ''}
        minLength={2}
        callback={() => console.log('callback')}
        label={'אימייל'}
        id={'email'}
        disabled={true}
        disabledOpacityStyle
      />

      {isLoading ? (
        <div className={styles.loaderContainer}>
          <div className={styles.simpleWhiteSpinner}></div>
        </div>
      ) : (
        <Checkbox
          id="newsletter"
          label={SignupTexts.ImInterestedInReceivingMarketingMails}
          checked={user?.newsletter ?? false}
          callback={handleNewsletterChange}
          isWhite={true}
        />
      )}
    </>
  )
}
export { ContactDetailsForm }
